import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Countrybase } from 'src/app/@core/models/country';
import { APIService } from 'src/app/@core/services/api.service';

@Injectable()
export class CountryService {

    constructor(private http: HttpClient, private _apiService: APIService) { }

    getCountries() {
        return this.http.get<any>('assets/demo/data/countries.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

    getAllCountries(): Observable<Countrybase> {
        return this._apiService.get('/ClusterAndCompanies/GetAllCountries');
    }
}
